import styled from 'styled-components'
import { GREEN } from '../../utils/colors'

export const Result = styled.div`
  font-size: 18px;
  line-height: 24px;
  color: #818181;
  vertical-align: middle;
  span {
    font-size: 30px;
    color: ${GREEN};
  }
`

export const Container = styled.div`
  margin: 44px 0px;
`
